import { render, staticRenderFns } from "./showTypeView.vue?vue&type=template&id=3d1f5b3e&"
import script from "./showTypeView.vue?vue&type=script&lang=js&"
export * from "./showTypeView.vue?vue&type=script&lang=js&"
import style0 from "./showTypeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports